import { EmailPreviewer } from './email-previewer'

$(document).ready(function() {
  const emailPreviewer = new EmailPreviewer('.preview', {
    body: '.body textarea',
    subject: '.subject input',
    placeholders: ['viewing', 'property', 'office'],
  })
  emailPreviewer.bind('.office-viewing-setting')
})
